import { useCallback, useContext, useMemo, useState, createContext } from "react";
import PropTypes from "prop-types";

export const SubscriptionPopupContext = createContext({});

export function useSubscriptionPopup() {
  return useContext(SubscriptionPopupContext);
}

export default function SubscriptionPopupProvider({ children }) {
  const [subscriptionPopupOpen, setPopupOpen] = useState(false);
  const [isFinalSale, setIsFinalSale] = useState(false);

  // Only update isFinalSale when opening, so the perks don't change during the close animation
  const setSubscriptionPopupOpen = useCallback((open, { isFinalSale: finalSale = false } = {}) => {
    if (open) setIsFinalSale(finalSale);
    setPopupOpen(open);
  }, []);

  const popUpData = useMemo(
    () => ({
      subscriptionPopupOpen,
      setSubscriptionPopupOpen,
      isFinalSale,
    }),
    [subscriptionPopupOpen, setSubscriptionPopupOpen, isFinalSale]
  );
  console.log(popUpData, " => popUpData");

  return (
    <SubscriptionPopupContext.Provider value={popUpData}>
      {children}
    </SubscriptionPopupContext.Provider>
  );
}

SubscriptionPopupProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
